import { createContext, useState } from 'react';

export const NavContext = createContext(null);

export const NavProvider = ({ children }) => {
    const [navState, setNavState] = useState({
        showHeader: true,
        showSidebar: true,
        showSecondarySidebar: false,
        isCalendar: false,
        isPeople: false,
    });

    //const [person, setPerson] = useState(null);
    const [showHeader, setShowHeader] = useState(true);
    const [showSidebar, setShowSidebar] = useState(true);
    const [showSecondarySidebar, setShowSecondarySidebar] = useState(false);
    const [isCalendar, setIsCalendar] = useState(false);
    const [isPeople, setIsPeople] = useState(false);

    const changeNavState = (newNavState) => {
        setNavState(newNavState);
    };

    const props = {
        /*showHeader,
        setShowHeader,
        showSidebar,
        setShowSidebar,
        showSecondarySidebar,
        setShowSecondarySidebar,
        isCalendar,
        setIsCalendar,
        isPeople,
        setIsPeople,*/
        navState,
        setNavState,
        changeNavState,
    };

    return (
        <NavContext.Provider
            value={props}
        >
            {children}
        </NavContext.Provider>
    );
};